export default "__VITE_ASSET__DHjpj36z__"